<!-- TEMPLATE -->
<template>
  <div :class='quotesOverviewClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
            <span class='avenir-heavy'>Offertes</span>
          </span>
                    <dean-section-title-item
                            :icon='archiveIcon'
                            :content="true"
                            @click.native="sectionRoute('quotes.overview.status', {status: 'deleted'})"
                    >
                        Archief
                    </dean-section-title-item>
                    <dean-section-title-item
                        v-if="$store.getters.getUser.privileges.includes('create-quote')"
                            :icon='plusIcon'
                            :content="true"
                            @click.native="sectionRoute('quotes.add.customers.list')"
                    >
                        Offertes Toevoegen
                    </dean-section-title-item>
                </dean-section-title>
                <div class="filter">
                    <dean-form-row
                            @input="update(true)"
                            v-model="pageMeta.query"
                            class="top-bar"
                            hide-label="true"
                    >zoek
                    </dean-form-row>
                    <dean-form-row
                            @input="update"
                            v-model="pageMeta.startDate"
                            class="top-bar"
                            hide-label="true"
                            type="date"
                    >startdatum
                    </dean-form-row>
                    <dean-form-row
                            @input="update"
                            v-model="pageMeta.endDate"
                            class="top-bar"
                            hide-label="true"
                            type="date"
                    >einddatum
                    </dean-form-row>
                    <button :class="{active: pageMeta.cloudService == true}" id="servicecloud">
                        <dean-icon
                                :glyph="deanCloudIcon"
                                @click.native="pageMeta.cloudService = !pageMeta.cloudService; update()"
                                width="20"
                                height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="servicecloud" placement="bottom">
                        Cloud
                    </b-tooltip>

                    <button :class="{active: pageMeta.connectionService == true}" id="serviceconnection">
                        <dean-icon :glyph="deanInternetIcon"
                                   @click.native="pageMeta.connectionService = !pageMeta.connectionService; update()"
                                   width="20"
                                   height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="serviceconnection" placement="bottom">
                        Connection
                    </b-tooltip>

                    <button :class="{active: pageMeta.mobileService == true}" id="servicemobile">
                        <dean-icon :glyph="deanMobileOdidoIcon"
                                   @click.native="pageMeta.mobileService = !pageMeta.mobileService; update()"
                                   width="20"
                                   height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="servicemobile" placement="bottom">
                        Odido Mobile
                    </b-tooltip>

                    <button :class="{active: pageMeta.mobileKpnService == true}" id="servicemobilekpn">
                      <dean-icon :glyph="deanMobileKpnIcon"
                                 @click.native="pageMeta.mobileKpnService = !pageMeta.mobileKpnService; update()"
                                 width="20"
                                 height="20"
                      ></dean-icon>
                    </button>
                    <b-tooltip target="servicemobilekpn" placement="bottom">
                      KPN Mobile
                    </b-tooltip>

                    <button :class="{active: pageMeta.sipTrunkService == true}" id="servicesiptrunk">
                        <dean-icon :glyph="deanSipTrunkIcon"
                                   @click.native="pageMeta.sipTrunkService = !pageMeta.sipTrunkService; update()"
                                   width="20"
                                   height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="servicesiptrunk" placement="bottom">
                        Sip Trunk
                    </b-tooltip>
                </div>
                <dean-table
                        :data='quotesData'
                        :columns='columns'
                        :hover="true"
                        @column-click='columnClick'
                        @cell-click="cellClick"
                >
                </dean-table>
                <dean-pagination
                        :current-page='quotesMetaData.pageNumber'
                        :total-items='quotesMetaData.totalResults'
                        :items-per-page='quotesMetaData.itemsPerPage'
                        :select-items-per-page='selectItemsPerPage'
                        :visible-pages='quotesMetaData.visiblePages'
                        @page-changed='paginationChanged'
                        @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import axios from 'axios';
  import {BTooltip} from 'bootstrap-vue';
  import {getDutchDateFormat} from '@/mixins/dateWrapper';
  import {formatPrice} from '@/mixins/formatPrice';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    archiveIcon,
    summeryIcon,
    deanCloudIcon,
    deanInternetIcon,
    customIconPhoneCall,
    customIconSmartphoneKpn,
    customIconSmartphoneOdido,
  } from '@deanone/dean-components';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      archiveIcon,
      summeryIcon,
      deanFormRow,
      BTooltip,
    },
  })
  export default class List extends mixins(deanTableMixin) {
    // DATA
    public quotes: object = {};
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public deanCloudIcon: object = deanCloudIcon;
    public deanInternetIcon: object = deanInternetIcon;
    public deanMobileOdidoIcon: object = customIconSmartphoneOdido;
    public deanMobileKpnIcon: object = customIconSmartphoneKpn;
    public deanSipTrunkIcon: object = customIconPhoneCall;
    public queryTimeout!: number;
    public sideMenu: object = {
      content: {
        title: {
          text: 'Offertes',
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        sections: {
          filters: {
            title: 'status',
            items: {
              summery: {
                title: 'Overzicht',
                icon: summeryIcon,
                name: 'quotes.overview',
              },
              active: {
                title: 'Gewonnen',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'won'},
              },
              blocked: {
                title: 'Verworpen',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'discarded'},
              },
              inactive: {
                title: 'Verloren',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'lost'},
              },
              archived: {
                title: 'Archief',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'deleted'},
              },
            },
          },
        },
      },
    };

    // COMPUTED
    get columns(): any {
      const columns: any = {
        number: {
          content: 'Offerte-id',
          align: 'left',
          sort: true,
          dql: 'number',
        },
        customerName: {
          content: 'Klantnaam',
          align: 'left',
          sort: true,
          dql: 'customerName',
        },
      };
      if (this.$store.getters.getUser.privileges.includes('view-partner')) {
        columns.partnerName = {
          content: 'Partnernaam',
          align: 'left',
          sort: true,
          dql: 'partnerName',
        };
      }
      return {
        ...columns, ...{
          pchsnr: {
            content: 'Pc/Hsnr',
            align: 'left',
            sort: true,
            dql: 'pchsnr',
          },
          city: {
            content: 'Plaats',
            align: 'left',
            sort: true,
            dql: 'city',
          },
          quoteDate: {
            content: 'Datum',
            align: 'left',
            sort: true,
            dql: 'created',
          },
          recurringPrice: {
            content: 'Maandelijks',
            align: 'left',
            sort: true,
            dql: 'recurringPrice',
          },
          status: {
            content: 'Status',
            align: 'left',
            // sort: true, # there are only concepts on this list
            dql: 'status',
          },
        },
      };
    }

    get quotesOverviewClass() {
      let value = 'quotes-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get quotesData() {
      return this.quotes;
    }

    get quotesMetaData() {
      return this.pageMeta;
    }

    public cellClick(target: any, column: string) {
      if (
          target.row.status === 'Gewonnen'
          && this.$store.getters.getUser.privileges.includes('view-order')
      ) {
        this.$router.push({
          name: 'orders.orderlines',
          params: {
            transactionId: target.row.transactionId,
          },
        });
      } else if (this.$store.getters.getUser.privileges.includes('view-quote')) {
        this.$router.push({
          name: 'quotes.edit',
          params: {
            id: target.row.id,
          },
        });
      } else {
        return;
      }
    }

    public tableName(): string {
      return 'quotes';
    }

    // METHODS
    public update(timeout: boolean) {
      this.pageMeta.pageNumber = 1;

      if (timeout) {
        const self = this;
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(this.pageMeta);
        }, 500);
      } else {
        this.loadList(this.pageMeta);
      }
    }

    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      let quotesListRequestUrl: string;

      if (
        this.$store.getters.getUser.organization
        &&
        this.$store.getters.getUser.organization.isProvider
      ) {
        quotesListRequestUrl = '/-/trade/api/admin.quotes.list';
      } else {
        quotesListRequestUrl = '/-/trade/api/quotes.list';
      }

      axios
        .post(quotesListRequestUrl, {
          meta: {
            startIndex: ((data.pageNumber - 1) * data.itemsPerPage) || 0, // TODO move calc somewhere else ?
            numberOfItems: data.itemsPerPage,
          },
          sort: data.sort,
          filter: this.pageMeta.query,
          status: this.$route.params.status,
          startDate: this.pageMeta.startDate,
          endDate: this.pageMeta.endDate,
          partnerId: !this.$store.getters.getUser.organization.isProvider
            && this.$store.getters.getPartnerAgreement
            ? this.$store.getters.getUser.organizationId : undefined,
          connectionService: this.pageMeta.connectionService,
          cloudService: this.pageMeta.cloudService,
          mobileService: this.pageMeta.mobileService,
          mobileKpnService: this.pageMeta.mobileKpnService,
          sipTrunkService: this.pageMeta.sipTrunkService,
        })
        .then(
          (response) => {
            this.quotes = response.data.data.map((quote: any) => {
              return {
                id: quote.id,
                number: quote.number,
                customerName: quote.customer.name,
                partnerName: quote.partner.name,
                pchsnr: quote.address ? (quote.address.postalCode +
                    ' / ' +
                    quote.address.houseNumber + (
                        quote.address.houseNumberExtension ?
                            '-' + quote.address.houseNumberExtension :
                            ''
                    )
                ) : '-',
                city: quote.address ? quote.address.city : '-',
                quoteDate: getDutchDateFormat(quote.created),
                recurringPrice: formatPrice(quote.recurringPrice),
                status: quote.status,
                transactionId: quote.transactionId,
              };
            });

            this.updateMeta(response.data.meta);
            this.$store.dispatch('updateSideMenu', this.sideMenu);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => this.$store.dispatch('setLoadOverlay', false));
    }

  public created() {
    this.keepMetaSavedInState();
    this.$store.commit('SET_SIDEMENU', {});
    this.setDefaultSort('-created');
    this.loadList(this.pageMeta);
  }
}
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    .filter {
        display: flex;
    }

    button {
        fill: var(--color-dark, $color-dark);
        background: none;
        padding: 5px;
        border: 0;
        margin: 5px;
        transition: fill .3s;
        border-radius: 5px;
    }

    button.active,
    button:hover {
        fill: var(--color-secondary, $color-secondary);
    }

    .top-bar {
        display: inline-block;
    }

    :deep(.top-bar .hd-6.columns) {
      width: 100%;
    }
</style>
